/**
 * ImpersonateScreen — l'ouverture d'une session impersonnée (`impersonate`), sur le design system.
 *
 * Un fil : l'échange du code (`useImpersonateState`), l'état (`impersonateStatus`), puis la page.
 * Remplace l'ancien `src/auth/ImpersonateScreen.js`. La route est posée dans toutes les piles.
 */
import { ImpersonatePage } from "../../../../../../design-system"
import { impersonateStatus } from "../../../../view-models/auth/Impersonate/impersonateViewModel"
import { AuthStatusBar } from "../AuthStatusBar"
import { useImpersonateState } from "./useImpersonateState"

type ImpersonateScreenProps = {
    route?: { params?: { code?: string } }
}

export function ImpersonateScreen({ route }: ImpersonateScreenProps) {
    const code = route?.params?.code
    const { failed } = useImpersonateState(code)

    return (
        <>
            <ImpersonatePage status={impersonateStatus(code, failed)} />
            <AuthStatusBar />
        </>
    )
}

export default ImpersonateScreen
